module.exports = __webpack_public_path__ + "static/media/ok.053f04c3.png";